
<component :is="tag" ref="root" data-theme="notch" class="n-tooltip-wrapper"><slot /></component>
